import type { ReactNode } from 'react';
import styled from 'styled-components';

import { media } from '../../../../helpers/breakpoints';

export interface HeroImageProps {
  cdnUrl: string;
  children?: ReactNode;
  image: string;
  imageSmall: string;
}

const Container = styled.div<{
  image: string;
  imageSmall: string;
  cdnUrl: string;
}>`
  position: relative;
  height: 264px;

  background: #999999 url('${({ image }) => image}') center;
  ${media.smallOnly} {
    background: #999999 url('${({ imageSmall }) => imageSmall}') center;
  }
  background-size: cover;
`;

const HighRes = styled.div<{
  image: string;
  imageSmall: string;
  cdnUrl: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.3s;
  background: transparent url('${({ image }) => image}') center;
  ${media.smallOnly} {
    background: transparent url('${({ imageSmall }) => imageSmall}') center;
  }
  background-size: cover;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.48);
  padding-top: 72px;
  display: flex;
  flex-direction: column;

  ${media.smallOnly} {
    padding-top: 80px;
  }
`;

function HeroImage({ children, cdnUrl, image, imageSmall }: HeroImageProps) {
  return (
    <>
      <Container image={image} imageSmall={imageSmall} cdnUrl={cdnUrl}>
        <HighRes image={image} imageSmall={imageSmall} cdnUrl={cdnUrl} />
        <Overlay>{children}</Overlay>
      </Container>
    </>
  );
}

export { HeroImage };
